// 需要授权且个人中心布局的路由
const user = [
  {
    path: '/study',
    name: 'study',
    meta: {
      title: '学习中心',
      type: 'menu',
      icon: 'el-icon-User',
      layout: 'auth',
      auth: true
    },
    redirect: '/study/course',
    children: [{
      path: 'course',
      name: 'studyCourse',
      meta: {
        title: '我的课程',
        type: 'menu',
        layout: 'auth',
        auth: true
      },
      component: () => import('@/views/user/study/course.vue')
    }]
  },
  {
    path: '/my',
    name: 'my',
    meta: {
      title: '我的信息',
      type: 'menu',
      icon: 'el-icon-Setting',
      layout: 'auth',
      auth: true
    },
    redirect: '/my/personal',
    children: [{
      path: 'personal',
      name: 'myPersonal',
      meta: {
        title: '个人中心',
        type: 'menu',
        layout: 'auth',
        auth: true
      },
      component: () => import('@/views/user/info/personal.vue')
    }, {
      path: 'order',
      name: 'myOrder',
      meta: {
        title: '我的订单',
        type: 'menu',
        layout: 'auth',
        auth: true
      },
      component: () => import('@/views/user/info/order.vue')
    }]
  }
]

export default user
